import { connect } from "react-redux";
import { createSelector } from "reselect";
import internalStateService from "../../app/InternalStateService";
import LoadingAnimationHOC from "@tinqin/tinqin-ui-components/src/loading-animation/LoadingAnimationHOC";
import { GlobalLoadingAnimation } from "./GlobalLoading";

const getGlobalLoadingSelector = state => {
    return state.getIn(["global", "applicationLoading"]);
};

const loadingProps = () => {
    let defaultData = {
        minLoadingTime: 0,
        contentRenderWaitingTime: 0,
        fadeinTime: 0,
        fadeoutTime: 500
    };
    if (internalStateService.getComponentsDefaultConfig()["applicationLoading"]) {
        return Object.assign(
            defaultData,
            internalStateService.getComponentsDefaultConfig()["applicationLoading"]
        );
    } else return defaultData;
};

const mapStateToProps = createSelector([getGlobalLoadingSelector], isLoading => {
    return { isLoading };
});

export default connect(mapStateToProps)(LoadingAnimationHOC(GlobalLoadingAnimation, loadingProps));
